module.exports = __webpack_public_path__ + "img/logo-ksg.34521b11.png";